/* Close Dawn's mobile drawer after a same-page anchor link is selected. */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('header-drawer .menu-drawer a[href]');
  if (!link) return;
  const destination = new URL(link.href, window.location.href);
  if (!destination.hash || destination.origin !== location.origin || destination.pathname !== location.pathname) return;
  const drawer = link.closest('header-drawer');
  const summary = drawer.querySelector('details > summary');
  if (summary && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  }
});
